// extracted by mini-css-extract-plugin
export var content = "_3-3";
export var footer = "_3-4";
export var header = "_3-1";
export var panel = "_3-0";
export var tabsWrapper = "_3-2";